import { getBusinessPath } from '@/utils/localeRoute.js'

const FORCE_DARK_ROUTES = ['/majroShareholder', '/christmas', '/coinStock', '/home', '/proofOfReserves', '/activity/worldCup', '/bffund']
const SWITCHABLE_THEME_ROUTES = ['/futures', '/trade', '/coinStockFutures', '/coinStockTrade']

const normalizeThemeRoutePath = (path = '') => getBusinessPath(path)

const isForceDarkRoute = (path = '') => {
  const businessPath = normalizeThemeRoutePath(path)
  return FORCE_DARK_ROUTES.some(routePath => businessPath.startsWith(routePath)) || businessPath.startsWith('/ecoV2')
}
const isSwitchableThemeRoute = (path = '') => SWITCHABLE_THEME_ROUTES.includes(normalizeThemeRoutePath(path))

export {
  FORCE_DARK_ROUTES,
  SWITCHABLE_THEME_ROUTES,
  normalizeThemeRoutePath,
  isForceDarkRoute,
  isSwitchableThemeRoute,
}
